var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"value":_vm.item.lang}},[_c('v-list-item-avatar',{attrs:{"size":"24"}},[_vm._v(" "+_vm._s(_vm.item.flag)+" ")]),_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }